import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
const InitialModalContext = /*#__PURE__*/ React.createContext({
    initialModal: null
});
export const InitialModalProvider = (param)=>{
    let { children , initialModal  } = param;
    return /*#__PURE__*/ _jsx(InitialModalContext.Provider, {
        value: {
            initialModal
        },
        children: children
    });
};
export const useInitialModal = ()=>useContext(InitialModalContext).initialModal;
